import type {DocumentManager} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import {deepClone} from '@wix/wix-immutable-proxy'

const removeComponentStyle = (documentManager: DocumentManager, pointer: Pointer, compStructure: any) => {
    if (!compStructure.skin && !compStructure.styleId) {
        return
    }

    const componentStructure = deepClone(compStructure)
    delete componentStructure.skin
    const {styleId} = componentStructure
    const compPageId = componentStructure.metaData.pageId
    if (styleId && compPageId) {
        const styleItemPointer = documentManager.pointers.data.getThemeItem(styleId, componentStructure.metaData.pageId)
        documentManager.dal.remove(styleItemPointer)
        delete componentStructure.styleId
    }
    documentManager.dal.set(pointer, componentStructure)
}

const removeComponentStyleIfSkinMissing = (documentManager: DocumentManager, pointer: Pointer, compStructure: any) => {
    const {styleId} = compStructure
    const compPageId = compStructure.metaData.pageId
    if (styleId && compPageId) {
        const styleItemPointer = documentManager.pointers.data.getThemeItem(styleId, compPageId)
        const style = documentManager.dal.get(styleItemPointer)

        if (!style?.skin && !compStructure.skin) {
            removeComponentStyle(documentManager, pointer, compStructure)
        }
    }
}

const components = {
    'wixui.CustomElementComponent': removeComponentStyleIfSkinMissing,
    'wixui.LottieEmbed': removeComponentStyle
    // technically, these 2 also have no skin or style in the componentDefinition.
    // However, it doesn't mean that its not really working there, as the viewer component might still render with a skin/style
    // currently not adding these 2 so that we do not introduce unnecessary risk. We can uncomment these separately
    // after verifying the actual status in viewer in production
    // 'wysiwyg.viewer.components.Grid': migrateComponent,
    // 'wysiwyg.viewer.components.Table': migrateComponent
}

export {components}
